import { render, staticRenderFns } from "./MenusItems.vue?vue&type=template&id=3eeb500a&scoped=true"
import script from "./MenusItems.vue?vue&type=script&lang=js"
export * from "./MenusItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eeb500a",
  null
  
)

export default component.exports